import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import img1 from "../assests/images/unnamed.webp";

const exploreLinks = [
  { label: "Dive In", to: "/divein" },
  { label: "Math Solver", to: "/formula" },
  { label: "Note Making", to: "/notemaking" },
  { label: "Paraphrase", to: "/paraphrase" },
  { label: "Extract Text", to: "/extract" },
];

const infoLinks = [
  { label: "Home", to: "/home" },
  { label: "Subscription", to: "/subscription" },
  { label: "Resources", to: "/videos" },
  { label: "Feedback", to: "/feedback" },
  { label: "Login", to: "/login" },
];

const Footer = () => {
  return (
    <footer className="bg-brand-footer px-0 pb-9 pt-[72px]">
      <Container>
        <Row>
          <Col lg="4" md="6" className="mb-7 md:mb-0">
            <Link to="/home" className="mb-4 inline-flex items-center gap-2.5 no-underline">
              <img src={img1} alt="EzShiksha logo" className="h-[52px] w-[52px] object-contain" />
              <p className="m-0 font-display text-[1.45rem] font-bold leading-none !text-white">
                Ez<span className="!text-brand-teal">Shiksha</span>
              </p>
            </Link>
            <p className="mb-5 max-w-[280px] text-[0.98rem] leading-relaxed !text-white/70">
              Study tools that turn tough problems into clear next steps — math,
              notes, grammar, and image text in one place.
            </p>
            <div className="flex items-center gap-3">
              <a
                className="inline-flex h-[42px] w-[42px] items-center justify-center rounded-full border border-white/20 bg-white/10 no-underline transition hover:-translate-y-0.5 hover:bg-brand-teal"
                href="https://linkedin.com/in/tilakrathoure"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-line text-xl !text-white" />
              </a>
              <a
                href="https://github.com/TilakRathoure"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex h-[42px] w-[42px] items-center justify-center rounded-full border border-white/20 bg-white/10 no-underline transition hover:-translate-y-0.5 hover:bg-brand-teal"
                aria-label="GitHub"
              >
                <i className="ri-github-line text-xl !text-white" />
              </a>
            </div>
          </Col>

          <Col lg="4" md="6" className="mb-7 md:mb-0">
            <h6 className="mb-4 font-display text-sm font-semibold uppercase tracking-wider !text-white">
              Explore
            </h6>
            <ul className="m-0 flex list-none flex-col gap-2.5 p-0">
              {exploreLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="font-display text-[0.95rem] !text-white/70 no-underline transition hover:!text-brand-teal"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </Col>

          <Col lg="4" md="6">
            <h6 className="mb-4 font-display text-sm font-semibold uppercase tracking-wider !text-white">
              Information
            </h6>
            <ul className="m-0 flex list-none flex-col gap-2.5 p-0">
              {infoLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="font-display text-[0.95rem] !text-white/70 no-underline transition hover:!text-brand-teal"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </Col>
        </Row>

        <div className="mt-12 flex flex-wrap justify-between gap-3 border-t border-white/20 pt-5">
          <p className="m-0 text-sm leading-normal !text-white/60">
            © {new Date().getFullYear()} EzShiksha. All rights reserved.
          </p>
          <p className="m-0 text-sm leading-normal !text-white/60">
            Built for learners who want clarity, fast.
          </p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
